import type { PropertyPickerOption } from "@repo/ui/components/property-picker";
import { PRIORITY_LABEL } from "@/features/tasks/lib/task-activity";
import { TASK_STATUS_LABELS, TaskStatusIcon } from "@/features/tasks/lib/task-status";
import { TaskPriorityIcon } from "@/shared/status/task-priority-icon";

export const TASK_PRIORITY_OPTIONS: PropertyPickerOption[] = [
  {
    value: "routine",
    label: PRIORITY_LABEL.routine ?? "None",
    icon: <TaskPriorityIcon priority="routine" size={14} />,
  },
  { value: "urgent", label: PRIORITY_LABEL.urgent ?? "Low", icon: <TaskPriorityIcon priority="urgent" size={14} /> },
  { value: "asap", label: PRIORITY_LABEL.asap ?? "Medium", icon: <TaskPriorityIcon priority="asap" size={14} /> },
  { value: "stat", label: PRIORITY_LABEL.stat ?? "High", icon: <TaskPriorityIcon priority="stat" size={14} /> },
];

// `draft`/`requested` are creation-only states — listed (hidden) so the picker
// can resolve their label/icon when displayed as the current value, but they
// don't appear in the dropdown as selectable transition targets.
export const TASK_STATUS_OPTIONS: PropertyPickerOption[] = [
  {
    value: "draft",
    label: TASK_STATUS_LABELS.draft ?? "Draft",
    icon: <TaskStatusIcon status="draft" size={14} />,
    hidden: true,
  },
  {
    value: "requested",
    label: TASK_STATUS_LABELS.requested ?? "Requested",
    icon: <TaskStatusIcon status="requested" size={14} />,
    hidden: true,
  },
  { value: "ready", label: TASK_STATUS_LABELS.ready ?? "Todo", icon: <TaskStatusIcon status="ready" size={14} /> },
  {
    value: "in-progress",
    label: TASK_STATUS_LABELS["in-progress"] ?? "In Progress",
    icon: <TaskStatusIcon status="in-progress" size={14} />,
  },
  {
    value: "on-hold",
    label: TASK_STATUS_LABELS["on-hold"] ?? "On Hold",
    icon: <TaskStatusIcon status="on-hold" size={14} />,
  },
  {
    value: "completed",
    label: TASK_STATUS_LABELS.completed ?? "Completed",
    icon: <TaskStatusIcon status="completed" size={14} />,
  },
  {
    value: "cancelled",
    label: TASK_STATUS_LABELS.cancelled ?? "Cancelled",
    icon: <TaskStatusIcon status="cancelled" size={14} />,
  },
];
